import utils from "@/utils/index";

const DocMenuConfig = [
  {
    pages: [
      {
        heading: "Dashboard",
        route: `/${utils.getWL()}/dashboard`,
        svgIcon: "media/icons/duotune/art/art002.svg",
        fontIcon: "bi-app-indicator",
      },
    ],
  },
];

export default DocMenuConfig;
